import { render, staticRenderFns } from "./frontFiltroBusqueda.vue?vue&type=template&id=1f963352&scoped=true&"
import script from "./frontFiltroBusqueda.vue?vue&type=script&lang=js&"
export * from "./frontFiltroBusqueda.vue?vue&type=script&lang=js&"
import style0 from "./frontFiltroBusqueda.vue?vue&type=style&index=0&id=1f963352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f963352",
  null
  
)

export default component.exports